import { Component, Input, OnChanges, OnInit } from '@angular/core';

@Component({
    selector: 'kiene-ohrmarke',
    templateUrl: './ohrmarke.component.html',
    styleUrls: ['./ohrmarke.component.scss'],
})
export class OhrmarkeComponent implements OnInit, OnChanges {
    part1 = '';
    part2 = '';
    part3 = '';

    @Input('ohrmarke') ohrmarke: string;

    constructor() {}

    ngOnInit(): void {
        this.cutInPieces();
    }

    ngOnChanges(): void {
        this.cutInPieces();
    }

    cutInPieces() {
        if (this.ohrmarke) {
            if (this.ohrmarke.length === 15) {
                if (this.ohrmarke.startsWith('040')) {
                    this.part1 = this.ohrmarke.substring(0, 8);
                    this.part2 = this.ohrmarke.substring(8, 12);
                    this.part3 = this.ohrmarke.substring(12, 15);
                } else {
                    this.part1 = this.ohrmarke.substring(0, 10);
                    this.part2 = this.ohrmarke.substring(10, 15);
                }
            } else if (this.ohrmarke.length === 12) {
                this.part1 = this.ohrmarke.substring(0, 7);
                this.part2 = this.ohrmarke.substring(7, 12);
            } else if (this.ohrmarke.length === 11) {
                if (this.ohrmarke.startsWith('AT')) {
                    this.part1 = this.ohrmarke.substring(0, 4);
                    this.part2 = this.ohrmarke.substring(4, 8);
                    this.part3 = this.ohrmarke.substring(8, 11);
                } else {
                    this.part1 = this.ohrmarke;
                }
            } else if (this.ohrmarke.length === 10) {
                this.part1 = this.ohrmarke.substring(0, 5);
                this.part2 = this.ohrmarke.substring(5, 10);
            } else {
                this.part1 = this.ohrmarke;
            }
        }
    }
}
